const $ = require('jquery');
const {Router} = require('../../../js/common/router');
const tts = require('../../common/js/_tts.js');
import Constants from '../../common/js/Constants';
import Item from '../../common/js/Item';
/** @property {Function} modal */
const viewer = $('#viewer');
const prevBtn = $('#carousel .viewer-previous');
const nextBtn = $('#carousel .viewer-next');
const lang = document.documentElement.lang;
const lastPageCtn = document.querySelector('[data-last-page]');
const lastPage = lastPageCtn ? parseInt(lastPageCtn.dataset.lastPage) : 1;
const selector = $('main');
const body = $('body');
const collectionItems = sessionStorage.getItem('collectionItems');
let photoListItems = Array.from(document.querySelectorAll('.list-item')),
    photoList = [],
    ajaxInitRelated,
    ajaxInitPrContact;
let currentItem;

// List of tags that can be rendered as tags
let badgeableTags = {};

export {
    currentItem,
    photoList
};

$(document).ready(function () {
    if ($(collectionItems) !== undefined && $(collectionItems) !== null) {
        for (let i = 0; i < $(collectionItems).length; i++) {
            if ($(collectionItems).eq(i).hasClass('carousel-collection-item')) {
                $('.carousel-collection-list').append($(collectionItems).eq(i))
            }
        }
        $('.carousel-relateds-container').css('visibility', 'visible');
    }
    fillPhotoList();
    $(prevBtn).on('click', function (e) {
        e.preventDefault();
        prevPhoto();
    });
    $(nextBtn).on('click', function (e) {
        e.preventDefault();
        nextPhoto();
    });
    $(document).on('keyup', function (e) {
        if (viewer.hasClass('active')) {
            switch (e.key) {
                case 'ArrowLeft':
                    prevPhoto();
                    break;
                case 'ArrowRight':
                    nextPhoto();
                    break;
            }
        }
    });
    viewer.on('hidden.bs.modal', function () {
        resetCarousel();
    });
    initDownloadBtnHandler();
    $('.carousel.slide').carousel({
        interval: 3000,
        touch: true,
        keyboard: false,
        wrap: false,
        pause: 'hover',
    }).on('slid.bs.carousel', handleLookSlide);

    document.addEventListener('nextResultsFetched', () => {
        resetPhotoList();
    });

    if (!!document.body.dataset.config) {
        const showroomConfig = JSON.parse(document.body.dataset.config);
        badgeableTags = showroomConfig['badgeable_tags'] || {};
    }
});

body
    .on('click', '.photo-list-item > div.photo-list-item-link', open)
    .on('click', '.carousel-item-link', zoom);

/**
 * Open carousel
 *
 * @param event
 * @access private
 */
function open(event) {
    event.preventDefault();
    viewer.addClass('active');
    viewer.modal('show');
    currentItem = photoList[findBy('slug', this.parentElement.dataset.slug)];
    initCarousel();
    updateBtn();
}

function updateSessionStorage() {
    sessionStorage.setItem('query', JSON.stringify({
        'type': currentItem['type'],
        'designer': currentItem['designerSlug'],
        'season': currentItem['seasonSlug']
    }));
}

function hasSameDesignerSeasonType() {
    let result = JSON.parse(sessionStorage.getItem('query'));

    if (result === null) {
        return false;
    }

    return result['type'] === currentItem['type']
        && result['designer'] === currentItem['designerSlug']
        && result['season'] === currentItem['seasonSlug']
}

function hasSameDesigner() {
    let result = JSON.parse(sessionStorage.getItem('query'));

    if (result === null) {
        return false;
    }

    return result['designer'] === currentItem['designerSlug'];
}

/**
 * Build template and listen to close
 *
 * @param event
 * @access private
 */
function zoom(event) {
    const carouselItemLink = $(event.target.closest('.carousel-item-link'));

    if (!carouselItemLink) {
        return;
    }

    viewer.removeClass('active');
    let close = $('<div class="carousel-photo-zoom-btn"/>')
        .append('<i class="carousel-photo-zoom-close fal fa-times fa-3x"/>');
    let div = $('<div class="carousel-photo-zoom"/>')
        .append($('<img alt="" src="' + carouselItemLink.attr('href') + '"/>'))
        .append(close);
    body.prepend(div);
    $('.carousel-photo-zoom, .carousel-photo-zoom-btn').on('click', function () {
        viewer.addClass('active');
        $(this).closest('.carousel-photo-zoom').remove();
    });
    tts.photo(currentItem['slug'], 'photo_zoom');
    event.preventDefault();
}

/**
 * Get prev photo
 *
 * @access private
 */
function prevPhoto() {
    if (prevBtn.hasClass('disabled')) {
        return;
    }
    if (getCurrentItemPosition() === 0) {
        getDataPage('prev');
        if (currentItem['page'] !== 1) {
            prevBtn.addClass('loading');
        }
        $(document).ajaxComplete(function () {
            initCarousel();
        });

        return;
    }
    currentItem = photoList[getCurrentItemPosition() - 1];
    if (ajaxInitRelated && hasSameDesignerSeasonType() === false) {
        ajaxInitRelated.abort();
    }

    if (ajaxInitPrContact && hasSameDesigner()) {
        ajaxInitPrContact.abort();
    }
    initCarousel();
    updateBtn();
}

/**
 * Get next photo
 *
 * @access private
 */
function nextPhoto() {
    if (nextBtn.hasClass('disabled')) {
        return;
    }
    if (getCurrentItemPosition() === photoList.length - 1) {
        getDataPage('next');
        nextBtn.addClass('loading');
        $(document).ajaxComplete(function () {
            initCarousel();
        });

        return;
    }
    currentItem = photoList[getCurrentItemPosition() + 1];
    if (ajaxInitRelated && hasSameDesignerSeasonType() === false) {
        ajaxInitRelated.abort();
    }
    if (ajaxInitPrContact && hasSameDesigner()) {
        ajaxInitPrContact.abort();
    }
    initCarousel();
    updateBtn();
}

/**
 * Init carousel
 *
 * @access private
 */
function initCarousel() {
    resetCarousel();
    initCarouselContent();
    tts.photo(currentItem['slug'], 'photo_view');
}

/**
 * Call ajax (pagination)
 *
 * @param {string} direction
 * @access private
 */
function getDataPage(direction) {
    let query;
    let route = $('#results').attr('data-path');
    if ((currentItem['page'] === lastPage && getCurrentItemPosition() === photoList.length - 1)
        || (currentItem['page'] === 1 && getCurrentItemPosition() === 0)
        || nextBtn.hasClass('loading')
        || prevBtn.hasClass('loading')) {
        return;
    }
    switch (direction) {
        case 'next':
            let pageNext = parseInt(currentItem['page']) < lastPage ? parseInt(currentItem['page']) + 1 : currentItem['page'];
            query = Object.assign(
                selector.attr('data-query') ? JSON.parse(selector.attr('data-query')) : {},
                {'page': pageNext}
            );
            break;
        case 'prev':
            let pagePrev = parseInt(currentItem['page']) > 0 ? parseInt(currentItem['page']) - 1 : currentItem['page'];
            query = Object.assign(
                selector.attr('data-query') ? JSON.parse(selector.attr('data-query')) : {},
                {'page': pagePrev}
            );
            break;
    }
    $.ajax({
        url: Router.generate(route + '.' + lang, {'showroom': document.documentElement.getAttribute('data-showroom')}),
        method: 'GET',
        data: query
    }).done(function (data) {
        fillPhotoList(data, direction);
        currentItem = direction === 'next' ? photoList[getCurrentItemPosition() + 1] : photoList[getCurrentItemPosition() - 1];
        nextBtn.removeClass('loading');
        prevBtn.removeClass('loading');
    });
}

/**
 * reset carousel content
 *
 * @access private
 */
function resetCarousel() {
    viewer.find('img:not(.shop-icon, .moodboard-icon, .pr-icon, .carousel-collection-item-img)').attr('src', '/images/loader.gif');
    $('.carousel-prcontact').hide();
    if (hasSameDesignerSeasonType() === false) {
        $('.carousel-collection-item').remove();
        $('.carousel-relateds-container').css('visibility', 'hidden');
    }
    $('.carousel-individuals-item').remove();
    $('.carousel-details-footer-container').hide();
    $('.carousel-details-individuals').hide();
    $('.carousel-item-badge').hide();
    $('.carousel-media-description').hide();
    $('.carousel-item.carousel-item-prototype').remove();
    $('.carousel-item').addClass('active')
    $('.carousel-indicators li:not(.active)').remove();
    $('.carousel-indicators li').addClass('disabled');
    $('.controls').addClass('disabled');
    $('.viewer-body').removeAttr('data-has-embed');
    $('.viewer .additional-info, .viewer .details hr').remove();
}

function resetPhotoList() {
    photoListItems = Array.from(document.querySelectorAll('.list-item'));
    photoList = [];
    fillPhotoList();
}

/**
 * Init carousel content
 *
 * @access private
 */
function initCarouselContent() {
    let badge, worn;
    const lookCtn = viewer.find('.modal-photo-look');
    const carouselItemLink = viewer.find('.carousel-item:not(.carousel-item-prototype) .carousel-item-link');
    const img = document.createElement('img');
    const viewerBody = viewer.find('.viewer-body');
    const relatedsContainer = viewer.find('.carousel-relateds-container:not(.worn-looks)');

    viewer.find('.viewer-header').show();
    viewer.find('.modal-photo-designer').html(currentItem['designerName']);
    viewer.find('.modal-photo-season').html(currentItem['seasonName']);

    if (currentItem['details']) {
        lookCtn.html(currentItem['seasonName'] ? '— ' + currentItem['details'] : currentItem['details']);
    } else {
        lookCtn.html('');
    }

    viewer.find('.carousel-models').show();
    if (carouselItemLink) {
        carouselItemLink.attr('href', currentItem['medias'][0]['zoom']);
    }
    img.classList.add('d-block', 'w-100');
    img.src = currentItem['medias'][0]['view'];
    img.addEventListener('load', function() {
        this.classList.add('loaded')
        const carouselItem = document.querySelector('.carousel-item:not(.carousel-item-prototype) img');
        carouselItem.replaceWith(img);
        setHeightDetails();
    });

    if (currentItem['medias'].length > 1) {
        viewer.find('.controls, .carousel-indicators li').removeClass('disabled');
        const prototypeItem = $('.carousel-inner .carousel-item-prototype');
        for (let i = 1; i < currentItem['medias'].length; i++) {
            let itemBlock = $(prototypeItem).clone();
            viewer.find('.carousel-indicators').append(`<li data-target="#carousel" data-slide-to="${i}"></li>`);
            if (currentItem['medias'][i].embed) {
                let params = [];
                if (currentItem['medias'][i]['url'].includes('youtube')) {
                    const id = currentItem['medias'][i]['url'].split('/embed/')[1];
                    params = ['controls=0', 'modestbranding=1', 'rel=0', 'autoplay=1', 'loop=1', `playlist=${id}`, 'mute=1'];
                }
                const iframe = $(`<div class="embed-responsive embed-responsive-1by1"><iframe class="embed-file embed-responsive-item w-100 h-100" src="${currentItem['medias'][i]['url']}?${params.join('&')}"></div>`);

                if (!!window.CustomizeIframe) {
                    window.CustomizeIframe(iframe);
                }

                itemBlock.html(iframe);
                itemBlock.find('iframe').on('load', function() {
                    $(this).addClass('loaded');
                });

                viewerBody.attr('data-has-embed', true);
            } else {
                const carouselItemLink = itemBlock.find('.carousel-item-link');
                if (carouselItemLink) {
                    carouselItemLink.attr('href', currentItem['medias'][i]['zoom']);
                }
                itemBlock.find('img').attr('src', currentItem['medias'][i]['view'])
                itemBlock.find('img').on('load', function() {
                    $(this).addClass('loaded');
                });
            }
            $('.carousel-inner').append(itemBlock.addClass('carousel-item'));
        }
    }
    viewer.find('.carousel-details-courtesy').html(currentItem['medias'][0]['courtesy']);
    initPrContact();
    initMediaDescription();

    if (currentItem['designerSlug'] !== undefined &&
        currentItem['seasonSlug'] !== undefined &&
        relatedsContainer.length > 0
    ) {
        initRelatedPhotos();
    }

    const tagsAsBadges = (currentItem.tags || [])
        .filter(tag => !!badgeableTags[tag.slug])
        .map(tag => badgeableTags[tag.slug]);

    badge = currentItem['badge'];
    worn = currentItem['worn'];

    if (badge !== null || worn !== false || tagsAsBadges.length > 0) {
        badge = badge ? badge.split('\n').join('<br/>') : '';
        worn =  worn ? Translator.trans('results.worn') : '';

        let badges = [];

        if (badge.length > 0) {
            badges.push(`<div class="carousel-item-badge watermark">${badge}</div>`);
        }

        if (tagsAsBadges.length > 0) {
            tagsAsBadges.sort();
            for (let tag of tagsAsBadges) {
                badges.push(`<div class="carousel-item-badge">${tag}</div>`);
            }
        }

        if (worn.length > 0) {
            badges.push(`<div class="carousel-item-badge worn">${worn}</div>`);
        }

        viewer.find('.carousel-item-badges').show().html(badges.join(''));
    }

    initCarouselContentEvent(currentItem);
}

/**
 * Call ajax (see all collection)
 *
 * @access private
 */
function initRelatedPhotos() {
    let query = {
        'type': currentItem['type'],
        'designer': currentItem['designerSlug'],
        'season': currentItem['seasonSlug'],
        'showroom': document.documentElement.getAttribute('data-showroom')
    };
    if (hasSameDesignerSeasonType() === false) {
        const collectionBlock = $('.carousel-details-collection');
        const collectionList = $('.carousel-collection-list');
        const prototypeItem = $('.carousel-collection-prototype');
        query['showroom'] = document.documentElement.getAttribute('data-showroom');
        let collectionLink = Router.generate('look_search.' + lang, query);
        if (!sessionStorage.getItem('query')) {
            sessionStorage.setItem('query', JSON.stringify(query));
        }
        updateSessionStorage();
        viewer.find('.carousel-relateds-container').css('visibility', 'visible');
        collectionBlock.attr('href', collectionLink);
        ajaxInitRelated = $.ajax({
            url: Router.generate('look_related.' + lang, {'showroom': document.documentElement.getAttribute('data-showroom')}),
            method: 'GET',
            global: false,
            data: query
        }).done(function (data) {
            $.each(data, function (i, item) {
                let itemBlock = prototypeItem.clone();
                itemBlock.attr('class', 'carousel-collection-item');
                itemBlock.show();
                itemBlock.find('img').addClass('carousel-collection-item-img').attr('src', item.files[0]['path_thumbnail']);
                collectionList.append(itemBlock);
            });
            sessionStorage.setItem('collectionItems', $('.carousel-collection-list').html());
        });
    } else {
        let collectionLink = Router.generate('look_search.' + lang, query);
        $('.carousel-details-collection').attr('href', collectionLink);
    }
}

function initPrContact() {
    if (currentItem['designerDetails']) {
        $('.carousel-prcontact').show();
        viewer.find('.carousel-prcontact-body').html(currentItem['designerDetails']);
    }
}

function initMediaDescription() {
    if (currentItem['description']) {
        $('.carousel-media-description').show();
        viewer.find('.carousel-media-descritpion-body').html(currentItem['description']);
    }
}

/**
 * Adapt the height of a media details (PR contact, description)
 * Check if element has already loaded or wait for the load to complete
 */
const setHeightDetails = () => {
    const element = document.querySelector('.carousel-item.active img') || document.querySelector('.carousel-item.active iframe');
    const viewerBody = document.querySelector('.viewer-body');

    if (element.classList.contains('embed-file')) {
        viewerBody.classList.add('embed');
        viewerBody.classList.remove('image');
    } else {
        viewerBody.classList.remove('embed');
        viewerBody.classList.add('image');
    }

    if (window.innerWidth >= Constants.desktopWidth) {
        if (element.classList.contains('loaded')) {
            setHeight(element);
        } else {
            element.addEventListener('load', () => setHeight(element), {once:true});
        }
    }
}

/**
 * Get heights sum of all elements in the details container minus the element height
 * and set the details footer container height with result
 * Set viewer landscape according to ratio
 * @param {HTMLElement} elem
 */
const setHeight = (elem) => {
    let ratio = elem.offsetWidth / elem.offsetHeight;
    ratio > 1 ? viewer.addClass('landscape') : viewer.removeClass('landscape')
    let heightSum = 0;
    const heights = [
        document.querySelector('.carousel-details-footer'),
        document.querySelector('.carousel-details .requests'),
        document.querySelector('.download-img-container'),
        17
    ]
    heights.map(height => {
        heightSum += !Number.isInteger(height) && height !== null ? height.offsetHeight : height;
    })
    document.querySelector('.carousel-clearfix .details').style.height = `${elem.offsetHeight - heightSum}px`;
}

/**
 * Init photo list or concat news data
 *
 * @param {array} [data]
 * @param {string} [direction]
 * @access private
 */
function fillPhotoList(data, direction) {
    if (data === undefined && direction === undefined) {
        photoListItems.map(item => {
            photoList.push(Item.initFromJsonLd(JSON.parse(item.innerText)));
        })
        initPhotoListEvent();
        return;
    }
    switch (direction) {
        case 'next':
            for (let i = 0; i < data.length; i++) {
                photoList.push(data[i]);
            }
            initPhotoListEvent();
            break;
        case 'prev':
            for (let i = data.length; i--;) {
                if (data[i] !== undefined) {
                    photoList.unshift(data[i]);
                }
            }
            initPhotoListEvent();
            break;
    }
}

/**
 * Get position of current item
 *
 * @access private
 * @returns {number}
 */
function getCurrentItemPosition() {
    return photoList.indexOf(currentItem);
}

/**
 * Check if current attribute is undefined or null
 *
 * @param {string} attr
 * @returns {boolean}
 */
function isEmptyInCurrent(attr) {
    return currentItem[attr] === undefined || currentItem[attr] === null || !currentItem[attr].length;
}

/**
 * Find By attr
 * @param {string} attr
 * @param {string} value
 * @returns {number}
 */
function findBy(attr, value) {
    for (let i = 0; i < photoList.length; i++) {
        if (photoList[i][attr] === value) {
            return i;
        }
    }
    return 0
}

/**
 * Update btn addClass/RemoveClass
 */
function updateBtn() {
    if (currentItem['page'] === lastPage && getCurrentItemPosition() === photoList.length - 1) {
        nextBtn.addClass('disabled');
    } else {
        nextBtn.removeClass('disabled');
    }

    if (currentItem['page'] === 1 && getCurrentItemPosition() === 0) {
        prevBtn.addClass('disabled');
    } else {
        prevBtn.removeClass('disabled');
    }
}

/**
 * Attach click event handler to button
 * Creates new link element, insert it into DOM, simulates click then remove element
 */
function initDownloadBtnHandler() {
    if (document.querySelector('.download-img-link') !== null) {
        document.querySelector('.download-img-link').addEventListener('click', function (e) {
            e.preventDefault();
            const filename = `${currentItem['designerSlug']}-${currentItem['seasonSlug']}-look-${currentItem['look']}`;
            const url = Router.generate(
                'download_photo.' + lang,
                {
                    'id': currentItem['slug'],
                    'showroom': document.documentElement.getAttribute('data-showroom'),
                    filename,
                }
            );
            tts.photo(currentItem['slug'], 'photo_download');
            document.location.href=url;
        })
    }
}

const initPhotoListEvent = () => {
    const event = new Event('photoListFilled');
    const viewerSelector = document.querySelector('.viewer');
    if (photoList.length > 0) {
        viewerSelector.dispatchEvent(event);
    }
}

const initCarouselContentEvent = (item) => {
    const event = new MessageEvent('initcarouselcontent', { data: item });
    document.querySelector('.viewer').dispatchEvent(event);
}

const handleLookSlide = (slideEvent) => {
    const courtesy = currentItem['medias'][slideEvent.to]['courtesy'];
    viewer.find('.carousel-details-courtesy').html(courtesy);

    setHeightDetails();
}
